export default __webpack_public_path__ + "static/media/logoSample3.2a36b0ec.png";